import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import './App.css';
import SignIn from './components/SignIn';
import Dashboard from './components/Dashboard';
import AdminDashboard from './components/AdminDashboard';
import AdminLogin from './components/AdminLogin';
import WatchlistPage from './components/WatchlistPage';
import HighLowPage from './components/HighLowPage';
import RuleStrategyPage from './components/RuleStrategyPage';
import IndexMoverPage from './components/IndexMoverPage';
import NiftyItPage from './components/NiftyItPage';
import NetPositionPage from './components/NetPositionPage';
import DistributionPage from './components/DistributionPage';
import SectorOverview from './components/SectorOverview';
import SectorRotation from './components/SectorRotation';
import IntradayScan from './components/IntradayScan';
import NiftyRealty from './components/NiftyRealty';
import MomentumRadar from './components/MomentumRadar';
import Heatmap from './components/Heatmap';
import OilMonitor from './components/OilMonitor';
import SWPCalculator from './components/SWPCalculator';
import SIPCalculator from './components/SIPCalculator';
import FiiDiiData from './components/FiiDiiData';
import BulkDealsPage from './components/BulkDealsPage';
import ProfilePage from './components/ProfilePage';
import TradersDiary from './components/TradersDiary';
import Blog from './components/Blog';
import BlogAdmin from './components/BlogAdmin';
import MainPage from './components/MainPage';
import NavigationWrapper from './components/NavigationWrapper';
import { WatchlistProvider } from './context/WatchlistContext';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [user, setUser] = useState(null);
  

  useEffect(() => {
  // Check if user is already authenticated
  const userData = localStorage.getItem('user');
  if (userData && userData !== 'undefined') {  // Add check for 'undefined' string
    try {
      const parsedData = JSON.parse(userData);
      if (parsedData && typeof parsedData === 'object') {  // Validate it's an object
        setUser(parsedData);
        setIsAuthenticated(true);
      }
    } catch (error) {
      console.error('Error parsing user data:', error);
      localStorage.removeItem('user');
    }
  }
  setIsLoading(false);
}, []);

  const handleSuccessfulLogin = (userData) => {
    setUser(userData);
    setIsAuthenticated(true);
    localStorage.setItem('user', JSON.stringify(userData));
  };

  const handleLogout = () => {
    localStorage.removeItem('user');
    setIsAuthenticated(false);
    window.location.href = '/';
  };

  if (isLoading) {
    return (
      <div className="App">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <WatchlistProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={
              isAuthenticated ? (
                user?.is_admin ? (
                  <Navigate to="/admin" />
                ) : (
                  <Navigate to="/dashboard" />
                )
              ) : (
                <MainPage onSuccessfulLogin={handleSuccessfulLogin} />
              )
            } />
            <Route path="/login" element={
              isAuthenticated ? (
                user?.is_admin ? (
                  <Navigate to="/admin" />
                ) : (
                  <Navigate to="/dashboard" />
                )
              ) : (
                <SignIn onSuccessfulLogin={handleSuccessfulLogin} />
              )
            } />
            <Route path="/dashboard" element={
              isAuthenticated ? (
                user?.is_admin ? (
                  <Navigate to="/admin" />
                ) : (
                  <NavigationWrapper>
                    <Dashboard 
                      onLogout={handleLogout}
                    />
                  </NavigationWrapper>
                )
              ) : (
                <Navigate to="/" />
              )
            } />
            <Route path="/watchlist" element={
              isAuthenticated ? (
                <NavigationWrapper>
                  <WatchlistPage />
                </NavigationWrapper>
              ) : (
                <Navigate to="/" />
              )
            } />
            <Route path="/highlow" element={
              isAuthenticated ? (
                <NavigationWrapper>
                  <HighLowPage />
                </NavigationWrapper>
              ) : (
                <Navigate to="/" />
              )
            } />
            <Route path="/rule-strategy" element={
              isAuthenticated ? (
                <NavigationWrapper>
                  <RuleStrategyPage />
                </NavigationWrapper>
              ) : (
                <Navigate to="/" />
              )
            } />
            <Route path="/index-mover" element={
              isAuthenticated ? (
                <NavigationWrapper>
                  <IndexMoverPage />
                </NavigationWrapper>
              ) : (
                <Navigate to="/" />
              )
            } />
            <Route path="/nifty-it" element={
              isAuthenticated ? (
                <NavigationWrapper>
                  <NiftyItPage />
                </NavigationWrapper>
              ) : (
                <Navigate to="/" />
              )
            } />
            <Route path="/net-position" element={
              isAuthenticated ? (
                <NavigationWrapper>
                  <NetPositionPage />
                </NavigationWrapper>
              ) : (
                <Navigate to="/" />
              )
            } />
            <Route path="/distribution" element={
              isAuthenticated ? (
                <NavigationWrapper>
                  <DistributionPage />
                </NavigationWrapper>
              ) : (
                <Navigate to="/" />
              )
            } />
            <Route path="/intraday-scan" element={
              isAuthenticated ? (
                <NavigationWrapper>
                  <IntradayScan />
                </NavigationWrapper>
              ) : (
                <Navigate to="/" />
              )
            } />
            <Route path="/momentum-radar" element={
              isAuthenticated ? (
                <NavigationWrapper>
                  <MomentumRadar />
                </NavigationWrapper>
              ) : (
                <Navigate to="/" />
              )
            } />
            <Route path="/heatmap" element={
              isAuthenticated ? (
                <NavigationWrapper>
                  <Heatmap />
                </NavigationWrapper>
              ) : (
                <Navigate to="/" />
              )
            } />
            <Route path="/oil-monitor" element={
              isAuthenticated ? (
                <NavigationWrapper>
                  <OilMonitor />
                </NavigationWrapper>
              ) : (
                <Navigate to="/" />
              )
            } />
            <Route path="/sip-calculator" element={
              isAuthenticated ? (
                <NavigationWrapper>
                  <SIPCalculator />
                </NavigationWrapper>
              ) : (
                <Navigate to="/" />
              )
            } />
            <Route path="/swp-calculator" element={
              isAuthenticated ? (
                <NavigationWrapper>
                  <SWPCalculator />
                </NavigationWrapper>
              ) : (
                <Navigate to="/" />
              )
            } />
            <Route path="/traders-diary" element={
              isAuthenticated ? (
                <NavigationWrapper>
                  <TradersDiary />
                </NavigationWrapper>
              ) : (
                <Navigate to="/" />
              )
            } />
            <Route path="/nifty-realty" element={
              isAuthenticated ? (
                <NavigationWrapper>
                  <NiftyRealty />
                </NavigationWrapper>
              ) : (
                <Navigate to="/" />
              )
            } />
            <Route path="/bulk-deals" element={
              isAuthenticated ? (
                <NavigationWrapper>
                  <BulkDealsPage />
                </NavigationWrapper>
              ) : (
                <Navigate to="/" />
              )
            } />
            <Route path="/fii-dii" element={
              isAuthenticated ? (
                <NavigationWrapper>
                  <FiiDiiData />
                </NavigationWrapper>
              ) : (
                <Navigate to="/" />
              )
            } />
            <Route path="/profile" element={
              isAuthenticated ? (
                <NavigationWrapper>
                  <ProfilePage />
                </NavigationWrapper>
              ) : (
                <Navigate to="/" />
              )
            } />
            <Route path="/sector-overview" element={
              isAuthenticated ? (
                <NavigationWrapper>
                  <SectorOverview />
                </NavigationWrapper>
              ) : (
                <Navigate to="/" />
              )
            } />
            <Route path="/sector-rotation" element={
              isAuthenticated ? (
                <NavigationWrapper>
                  <SectorRotation 
                    initialSector={sessionStorage.getItem('selectedSector') || 'Nifty 50'}
                  />
                </NavigationWrapper>
              ) : (
                <Navigate to="/" />
              )
            } />
            {/* Admin login gate - publicly accessible */}
            <Route path="/admin-login" element={<AdminLogin />} />
            {/* Admin routes - components handle their own session auth check */}
            <Route path="/admin" element={
              <AdminDashboard onLogout={handleLogout} />
            } />
            <Route path="/admin/blog" element={
              <BlogAdmin onBack={() => window.location.href = '/admin'} />
            } />
            {/* Blog page - accessible to all authenticated users */}
            <Route path="/blog" element={
              isAuthenticated ? (
                <Blog onBack={() => window.location.href = '/dashboard'} />
              ) : (
                <Navigate to="/" />
              )
            } />
          </Routes>
        </div>
      </Router>
    </WatchlistProvider>
  );
  
}

export default App;
